/* eslint-disable react/prop-types */
import React from 'react';
import get from 'lodash.get';

import { Ad } from 'Components/atoms/Ad';
import config from 'Config/config.json';

export const getRightSideAd = ({ adcount = 1, extraClassNames = null }) => {
  const adConfig = get(config, 'ads.slot-2');

  if (adConfig) {
    return (
      <Ad
        extraClassNames={extraClassNames}
        id={`refresh-right_${adcount}`}
        isSidebar
        key={`right-side-ad-${adcount}`}
        label="Advertisement"
        loadStyles
        targeting={{
          position: `right_${adcount}`,
          placement: `right_${adcount}`,
          refresh: 'yes',
        }}
        {...adConfig}
      />
    );
  }

  return false;
};
